import Vue from "vue";
import App from "./App.vue";

import "./registerServiceWorker";
import "@mdi/font/css/materialdesignicons.css";

import Buefy from "buefy";
import VueScrollTo from "vue-scrollto";
import BackToTop from "vue-backtotop";
import VueApexCharts from "vue-apexcharts";
import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";
import { SnackToast } from "@/utils/snackToast";
import { SnackQueue } from "@/plugins/SnackQueue";
import ActionsGrouper from "@/components/ActionsGrouper";
import CustomTagInput from "@/components/CustomTagInput";
import VueSocialSharing from "vue-social-sharing";
import VueClipboard from "vue-clipboard2";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ErrorField from "@/components/ErrorField";

import sentryInit from "./services/sentry/SentryInit";

import "./plugins/axios";
import "./plugins/vee-validate";

import "./utils/filters";

import router from "./router";
import store from "./store";
import VueMask from "v-mask";

import { configSocket } from "./services/Socket";

import { IndexedDBStore } from "./plugins/indexDB";

Vue.use(VueMask);

Vue.use(VueScrollTo);

Vue.use(VueFilterDateFormat);

Vue.config.productionTip = false;

Vue.use(Buefy);

Vue.use(BackToTop);

Vue.prototype.snackToast = SnackToast;
Vue.prototype.snackQueue = SnackQueue;
Vue.prototype.indexDB = new IndexedDBStore("persistentGeneric");

Vue.use(ActionsGrouper);
Vue.component("ActionsGrouper", ActionsGrouper);
Vue.component("CustomTagInput", CustomTagInput);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ErrorField", ErrorField);

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueSocialSharing);
Vue.use(VueClipboard);

!["development", "e2e"].includes(process.env.NODE_ENV) && sentryInit();
configSocket(store);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
